import { useMemo, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { authenticatedApiClient } from "@/lib/api-client";
import { isSessionValid } from "@/lib/auth-utils";

export function useApiClient() {
  const { user } = useAuth();

  // Check session validity only when the hook is first used with a user
  useEffect(() => {
    if (user) {
      // Check session validity once when the hook is used
      isSessionValid().then((isValid) => {
        if (!isValid) {
          console.warn("Session is not valid in useApiClient");
        }
      });
    }
  }, [user]);

  const apiClient = useMemo(() => {
    // Return the authenticated API client instance
    return authenticatedApiClient;
  }, []); // Remove dependencies to avoid recreating on every render

  return apiClient;
}
